export const UI_CONFIG_DEFINITION = {};
